import React, { useEffect, useState } from "react";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";

const nope = () => console.log("No function passed");
export const GenericConfirmationModal = (props) => {
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const {
    title = "",
    content = "",
    successBtnName = ct("Translate.buttonTitle.yesSmall"),
    cancelBtnName = ct("Translate.buttonTitle.noSmall"),
    onSuccess = nope,
    onCancel = nope,
    isLoading = false,
    className="",
    showOkButton = true,
    showCancelButton = true,
    size = "medium"
  } = props;

  useEffect(() => {
    return () => {
      if (isSubmitClicked) {
        setIsSubmitClicked(false);
      }
    }
  }, [])

  return (
    <Dialog
      {...props}
			disableAutoHideOnSubmit={true}
			disableBackdropClose={true}
			hideCloseButton={true}
			onCancel={() => onCancel(false)}
      onSubmit={() => {
        setIsSubmitClicked(true);
        onSuccess(true);
        setTimeout(() => {
          setIsSubmitClicked(false);
        }, 3000)
      }}
			cancel={{translationKey: cancelBtnName, hidden: !showCancelButton}}
      ok={{ translationKey: successBtnName, hidden: !showOkButton, disabled: isSubmitClicked }}
			titleKey={title}
      testId="media-msg-popup"
      zIndex={999}
			rtaClassName="confirmation-modal-wrapper"
      size={size}
    >
      <div className={`media-msg ${className}`}>{content}</div>
    </Dialog>
  );
};
